export const POScheduleInformationBadge = ({
    label = "",
    value = "",
}) => {
    return (
        <div className="rounded-md border border-border bg-white px-1 py-1 sm:py-2 sm:px-3">
            <p className="text-[10px] uppercase tracking-[0.14em] text-gray-600">{label}</p>
            <p className="mt-1 text-sm font-semibold text-primary">
                {value}
            </p>
        </div>
    )
}